import { Modal } from 'antd';
import { type FC } from 'react';
import type { TeamMemberInfo } from '@shared/api';
import { EditForm } from '../edit-form/edit-form';
import styles from './team-modal.module.scss';
import { CreateForm } from '../create-form/create-form';
import type { EditFormValues } from '@modules/team/lib/types';

interface TeamModalProps {
  organizationId: number;
  isOpen: boolean;
  isEditMode: boolean;
  selectedTeammate?: TeamMemberInfo;
  onDelete: () => void;
  onSubmit: (teamMemberId: number, values: EditFormValues) => Promise<void>;
  // onTransferOwner?: () => void;
  onClose: () => void;
}

export const TeamModal: FC<TeamModalProps> = ({
  organizationId,
  isOpen,
  isEditMode,
  selectedTeammate,
  onSubmit,
  onClose,
  // onTransferOwner,
  onDelete,
}) => (
  <Modal
    centered
    className={styles.space_modal}
    width={537}
    style={{ textAlign: 'center' }}
    open={isOpen}
    cancelButtonProps={{ hidden: true }}
    okButtonProps={{ hidden: true }}
    onCancel={onClose}
    closeIcon={false}
  >
    {isEditMode ? (
      <EditForm
        selectedTeammate={selectedTeammate}
        onClose={onClose}
        onSubmit={onSubmit}
        onDelete={onDelete}
        // onTransferOwner={onTransferOwner}
      />
    ) : (
      <CreateForm organizationId={organizationId} onClose={onClose} />
    )}
  </Modal>
);
